function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v15H0V7.5Z",
    style: {
      fill: "#012169"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1.619 15.028 7.5 12.088 13.38 15.028 14.986 15.028 15 15 15 14.161 9.177 11.25 15 8.338 15 7.5 13.322 7.5 7.5 10.411 1.678 7.5 0 7.5 0 8.338 5.822 11.25 0 14.161 0 15.001 .014 15.028 1.619 15.028",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1.061 15.028 7.5 11.809 13.939 15.028 14.986 15.028 15 15 15 14.44 8.617 11.25 15 8.059 15 7.5 13.881 7.5 7.5 10.69 1.119 7.5 0 7.5 0 8.059 6.382 11.25 0 14.44 0 15 .014 15.028 1.061 15.028",
    style: {
      fill: "#e4002b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.75 15 6.25 15 6.25 12.499 0 12.499 0 10 6.25 10 6.25 7.5 8.75 7.5 8.75 10 15 10 15 12.499 8.75 12.499 8.75 15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.249 15 6.75 15 6.75 12 0 12 0 10.499 6.75 10.499 6.75 7.5 8.249 7.5 8.249 10.499 15 10.499 15 12 8.249 12 8.249 15",
    style: {
      fill: "#e4002b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M7.5,16.5l.434,1.349,1.326-.502-.785,1.18,1.218.723-1.412.123.194,1.404-.976-1.027-.976,1.027.194-1.404-1.412-.122,1.218-.723-.785-1.18,1.326.502.434-1.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "c1",
    "data-name": "c",
    d: "M22.5,18.928l.206.642.631-.239-.373.562.58.345-.672.059.093.668-.465-.489-.465.489.093-.668-.672-.059.58-.345-.373-.562.631.239.206-.642Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "c2",
    "data-name": "c",
    d: "M18.749,12.991l.206.642.631-.239-.373.562.58.345-.672.059.093.668-.465-.489-.465.489.093-.668-.672-.059.58-.345-.373-.562.631.239.206-.642Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "c3",
    "data-name": "c",
    d: "M22.5,8.928l.206.642.631-.239-.373.562.58.345-.672.059.093.668-.465-.489-.465.489.093-.668-.672-.059.58-.345-.373-.562.631.239.206-.642Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "c4",
    "data-name": "c",
    d: "M25.833,11.991l.206.642.631-.239-.373.562.58.345-.672.059.093.668-.465-.489-.465.489.093-.668-.672-.059.58-.345-.373-.562.631.239.206-.642Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M24,15l.163.4.431.031-.331.279.103.42-.367-.227-.367.227.103-.42-.331-.279.431-.031.165-.4Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAu);
export default __webpack_public_path__ + "static/media/AU.9441f0dedd4c5fadca206410a4de17f1.svg";
export { ForwardRef as ReactComponent };